import React from 'react';
import { StyleSheet, View } from 'react-native';
import Icon from 'shared/components/vxl/icon/Icon/Icon';
import {
  getPasswordValidationStatus,
  passwordValidationMessages,
} from 'shared/components/vxl/input/schemas/password.schema';
import BodyXSText from 'shared/components/vxl/typography/primary/body/BodyXSText';
import theme from 'shared/styles/theme';

const ConfirmPasswordLabels = ({ newPassword }: { newPassword: string }) => {
  const passwordValidationStatus = getPasswordValidationStatus(newPassword);

  return (
    <View>
      <View style={styles.row}>
        <Icon
          iconKey="STATUS_SUCCESS"
          iconSize="SM"
          iconColor={
            passwordValidationStatus.minLength
              ? theme.color.interactive.primary
              : theme.color.text.muted
          }
        />
        <BodyXSText
          style={[
            styles.helperText,
            passwordValidationStatus.minLength ? styles.valid : undefined,
          ]}
        >
          {passwordValidationMessages.minimumLength}
        </BodyXSText>
      </View>

      <View style={styles.row}>
        <Icon
          iconKey="STATUS_SUCCESS"
          iconSize="SM"
          iconColor={
            passwordValidationStatus.hasLowerCase
              ? theme.color.interactive.primary
              : theme.color.text.muted
          }
        />
        <BodyXSText
          style={[
            styles.helperText,
            passwordValidationStatus.hasLowerCase ? styles.valid : undefined,
          ]}
        >
          {passwordValidationMessages.lowercase}
        </BodyXSText>
      </View>
      <View style={styles.row}>
        <Icon
          iconKey="STATUS_SUCCESS"
          iconSize="SM"
          iconColor={
            passwordValidationStatus.hasUpperCase
              ? theme.color.interactive.primary
              : theme.color.text.muted
          }
        />
        <BodyXSText
          style={[
            styles.helperText,
            passwordValidationStatus.hasUpperCase ? styles.valid : undefined,
          ]}
        >
          {passwordValidationMessages.uppercase}
        </BodyXSText>
      </View>
      <View style={styles.row}>
        <Icon
          iconKey="STATUS_SUCCESS"
          iconSize="SM"
          iconColor={
            passwordValidationStatus.hasNumber
              ? theme.color.interactive.primary
              : theme.color.text.muted
          }
        />
        <BodyXSText
          style={[
            styles.helperText,
            passwordValidationStatus.hasNumber ? styles.valid : undefined,
          ]}
        >
          {passwordValidationMessages.number}
        </BodyXSText>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  helperText: {
    color: theme.color.text.muted,
    marginLeft: theme.spacing.s,
  },
  row: {
    flexDirection: 'row',
  },
  valid: {
    color: theme.color.interactive.primary,
  },
});

export default ConfirmPasswordLabels;
